import { GetPlayerGames } from "@grassrootly/api/gateways/player";
import useBaseRequest from "../../api/BaseRequest";
import { store, useAppDispatch } from "@grassrootly/rn-core";
import { gameActions } from "../../api/game/GameReducer";
import { useFocusEffect } from "@react-navigation/native";
import { useCallback } from "react";

export function useMyGames() {
  const dispatch = useAppDispatch();

  const { loading, data, execute } = useBaseRequest(GetPlayerGames, {
    onCompleted: (data) => {
      if (!data || !data.length) return;
      dispatch(gameActions.setGames(data));
    },
  });

  const getMyGames = useCallback(() => {
    const playerId = store.getState().auth?.user?.id || 0;
    execute({ playerId });
  }, []);

  useFocusEffect(getMyGames);

  return { games: data, loading, execute };
}
